import { createRouter, createWebHistory } from 'vue-router'
import { cancelAllRequests } from '@/utils/request'
import { useUserInfoStore, useEnvStore } from '@/stores/index'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index.vue'),
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/login/index.vue'),
      meta: {
        title: '登录',
        noToken: true,
      },
    },
    {
      path: '/businessConfirmation',
      name: 'businessConfirmation',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/businessConfirmation.vue'),
      meta: {
        title: '手机号确认',
      },
    },
    {
      path: '/guide',
      name: 'guide',
      component: () => import('@/views/guide.vue'),
      meta: {
        title: '入驻指南',
      },
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import('@/views/rules.vue'),
      meta: {
        title: '推广规则',
      },
    },
    {
      path: '/certification',
      name: 'certification',
      component: () => import('@/views/certification/index.vue'),
      meta: {
        title: '推广认证',
      },
    },
    {
      path: '/poster',
      name: 'poster',
      component: () => import('@/views/poster.vue'),
      meta: {
        title: '分享购买',
      },
    },
    {
      path: '/settleAccounts-record',
      name: 'settleAccounts-record',
      component: () => import('@/views/settleAccounts/record.vue'),
      meta: {
        title: '结算记录',
      },
    },
    {
      path: '/settleAccounts-details',
      name: 'settleAccounts-details',
      component: () => import('@/views/settleAccounts/details.vue'),
      meta: {
        title: '结算详情',
      },
    },
    {
      path: '/promotion-record',
      name: 'promotion-record',
      component: () => import('@/views/promotion/record.vue'),
      meta: {
        title: '推广记录',
      },
    },
    {
      path: '/myProfile',
      name: 'myProfile',
      component: () => import('@/views/myProfile/index.vue'),
      meta: {
        title: '个人信息',
      },
    },
    {
      path: '/myProfile-info',
      name: 'myProfile-info',
      component: () => import('@/views/myProfile/info/info.vue'),
      meta: {
        title: '个人资料',
      },
    },
    {
      path: '/info-head',
      name: 'info-head',
      component: () => import('@/views/myProfile/info/head.vue'),
      meta: {
        title: '个人头像',
      },
    },
    {
      path: '/edit-mobile',
      name: 'edit-mobile',
      component: () => import('@/views/myProfile/info/editMobile/index.vue'),
      meta: {
        title: '修改手机号',
      },
    },
    {
      path: '/info-bankInfo',
      name: 'info-bankInfo',
      component: () => import('@/views/myProfile/info/bankInfo.vue'),
      meta: {
        title: '银行信息',
      },
    },
    {
      path: '/info-certification',
      name: 'info-certification',
      component: () => import('@/views/myProfile/certification.vue'),
      meta: {
        title: '资格认证',
      },
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('@/views/myProfile/contract.vue'),
      meta: {
        title: '合同管理',
      },
    },
    {
      path: '/accountSecurity',
      name: 'accountSecurity',
      component: () => import('@/views/myProfile/accountSecurity.vue'),
      meta: {
        title: '账号安全',
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/agreement/privacy.vue'),
      meta: {
        title: '隐私协议',
        noToken: true,
      },
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('@/views/signContract/apply.vue'),
      meta: {
        title: '申请',
      },
    },
    {
      path: '/sign',
      name: 'sign',
      component: () => import('@/views/signContract/sign.vue'),
      meta: {
        title: '签约',
      },
    },
    {
      path: '/review',
      name: 'review',
      component: () => import('@/views/signContract/review.vue'),
      meta: {
        title: '审核页面',
      },
    },
  ],
})
// H5 端的全局后置守卫
router.afterEach((to) => {
  // 1. 定义 H5 的根入口页面。到了这些页面，再按返回键就应该直接退出整个 App 的 webview
  // 结合你现有的路由配置，'/' 会重定向到 '/home'，所以核心一级页面是 '/home' 和 '/login'
  const rootPaths = ['/', '/home', '/login']
  const isRootPage = rootPaths.includes(to.path)

  // 2. 如果存在 uni 的 SDK 且在 webview 环境中，则向 App 发送消息
  if (window.uni && typeof window.uni.postMessage === 'function') {
    window.uni.postMessage({
      data: {
        action: 'updateHistory',
        canBack: !isRootPage // 如果不是首页或登录页，代表处于二级页面及以上，允许 App 拦截返回键
      }
    })
    console.log(`【H5路由通知】当前路径: ${to.path}，允许后退: ${!isRootPage}`)
  }
})
// 全局导航守卫动态修改标题
router.beforeEach(async (to, from, next) => {
  console.log('🚀 ~ from:', from)
  console.log('🚀 ~ to:', to)
  cancelAllRequests()
  const useUserInfo = useUserInfoStore()
  const useEnv = useEnvStore()
  if (!useUserInfo.getInitialized()) {
    // 是否是web环境
    // 如果是login页面或者不执行，不执行initialize
    if (useEnv.getEnv() == 'js') {
      if ((to.path == '/login' && from.path == '/') || to.meta.noToken) {
      } else {
        await useUserInfo.initialize()
      }
    } else {
      // 不是执行
      await useUserInfo.initialize()
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '推广'
  }
  next()
})

export default router
